<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['patient_debts']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <!-- Advanced Filters Section -->
              <div class="row mb-3">
                <div class="col-md-4">
                  <label class="form-label">Debt Amount Range</label>
                  <div class="d-flex gap-2">
                    <input type="number" v-model="filters.debtMin" class="form-control" placeholder="Min Amount">
                    <span class="align-self-center">-</span>
                    <input type="number" v-model="filters.debtMax" class="form-control" placeholder="Max Amount">
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Address</label>
                  <input class="form-control" list="patientaddress" v-model="filters.address" placeholder="Enter Address..."/>
                  <datalist id="patientaddress">
                    <option v-for="(addr, idx) in uniqueAddresses" :key="idx">{{ addr }}</option>
                  </datalist>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Search by Name</label>
                  <input type="text" v-model="filters.name" class="form-control" placeholder="Search patient name...">
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6 d-flex align-items-end">
                  <button class="btn btn-secondary me-2" @click="clearFilters">
                    <i class="mdi mdi-filter-remove"></i> Clear Filters
                  </button>
                  <button class="btn btn-info" @click="applyFilters">
                    <i class="mdi mdi-filter"></i> Apply Filters
                  </button>
                </div>
                <div class="col-md-6 d-flex align-items-end justify-content-end">
                  <button class="btn btn-danger" @click="exportToPDF">
                    <i class="mdi mdi-file-pdf"></i> Export to PDF
                  </button>
                </div>
              </div>

              <hr />

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <b-table
                  :items="filteredItems"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                  striped
                  hover
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ (currentPage - 1) * perPage + data.index + 1 }}
                </template>
                <template #cell(contact)="data">
                  0{{ data.item.contact }}
                </template>
                <template #cell(debt)="data">
                  {{ formatCurrency(data.item.debt) }}
                </template>
                </b-table>
              </div>

              <!-- Totals Section -->
              <div class="row mt-3">
                <div class="col-md-6">
                  <div class="alert alert-info">
                    <strong>Summary Statistics:</strong><br>
                    Total Patients with Debt: {{ filteredListLength }}<br>
                    Highest Debt: {{ formatCurrency(maxDebt) }}<br>
                    Lowest Debt: {{ formatCurrency(minDebt) }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="alert alert-success text-end">
                    <h4>Total Debt: {{ formatCurrency(totalDebt) }}</h4>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="filteredListLength" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Patients Debts</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { patientdebtorMethods, patientdebtorComputed } from "@/state/helpers";

export default {
  page: {
    title: "Patient Debts",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Patient Debts",
      items: [ {text: "Dashboard",to: "/",}, {text: "Patient Debts",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: ['name', 'patient_id', 'contact', 'address'],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true, sortable: true },
          { key: 'patient_id', label: 'Patient ID', visible: true, sortable: true },
          { key: 'name', label: 'Name', visible: true, sortable: true },
          { key: 'contact', label: 'Contact', visible: true, sortable: true },
          { key: 'address', label: 'Address', visible: true, sortable: true },
          { key: 'debt', label: 'Debt', visible: true, sortable: true },
        ],
      
      // Filters
      filters: {
        debtMin: '',
        debtMax: '',
        address: '',
        name: '',
        telephone: '',
        patientId: ''
      },
      appliedFilters: {}
    };
  },
  computed: {
    ...patientdebtorComputed,
    List() { return this.patientdebtors.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.patientdebtors.map((d) => ({...d }))},
    IsBusy() { return this.patientdebtors.length === 0 },
    
    // Unique addresses for datalist
    uniqueAddresses() {
      return [...new Set(this.patientdebtors.map(item => item.address).filter(addr => addr))];
    },
    
    // Apply all filters
    filteredItems() {
      let items = [...this.patientdebtors];
      
      // Debt amount range filter
      if (this.appliedFilters.debtMin) {
        items = items.filter(item => item.debt >= parseFloat(this.appliedFilters.debtMin));
      }
      if (this.appliedFilters.debtMax) {
        items = items.filter(item => item.debt <= parseFloat(this.appliedFilters.debtMax));
      }
      
      // Address filter
      if (this.appliedFilters.address) {
        items = items.filter(item => 
          item.address?.toLowerCase().includes(this.appliedFilters.address.toLowerCase())
        );
      }
      
      // Name filter
      if (this.appliedFilters.name) {
        items = items.filter(item => 
          item.name?.toLowerCase().includes(this.appliedFilters.name.toLowerCase())
        );
      }
      
      // Telephone filter
      if (this.appliedFilters.telephone) {
        items = items.filter(item => 
          item.contact?.toString().includes(this.appliedFilters.telephone)
        );
      }
      
      // Patient ID filter
      if (this.appliedFilters.patientId) {
        items = items.filter(item => 
          item.patient_id?.toString().includes(this.appliedFilters.patientId)
        );
      }
      
      return items;
    },
    
    filteredListLength() {
      return this.filteredItems.length;
    },
    
    totalDebt() {
      return this.filteredItems.reduce((total, item) => total + parseFloat(item.debt || 0), 0);
    },
    
    averageDebt() {
      if (this.filteredListLength === 0) return 0;
      return this.totalDebt / this.filteredListLength;
    },
    
    maxDebt() {
      if (this.filteredListLength === 0) return 0;
      return Math.max(...this.filteredItems.map(item => parseFloat(item.debt || 0)));
    },
    
    minDebt() {
      if (this.filteredListLength === 0) return 0;
      return Math.min(...this.filteredItems.map(item => parseFloat(item.debt || 0)));
    }
  },
  mounted() {
    this.fetchDebtors();
    this.TotalRows = this.patientdebtors.length;
    this.isBusy = false;
  },
  methods: {
    ...patientdebtorMethods,
    
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    
    formatCurrency(x) {
      if (!x && x !== 0) return '0';
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(x);
    },
    
    commas(x) {
      return this.formatCurrency(x);
    },
    
    applyFilters() {
      this.appliedFilters = { ...this.filters };
      this.currentPage = 1;
    },
    
    clearFilters() {
      this.filters = {
        debtMin: '',
        debtMax: '',
        address: '',
        name: '',
        telephone: '',
        patientId: ''
      };
      this.appliedFilters = {};
      this.currentPage = 1;
    },
    
    // Export to PDF using browser print
    exportToPDF() {
      if (this.filteredListLength === 0) {
        this.$bvToast.toast('No data to export!', {
          title: 'Warning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000
        });
        return;
      }
      
      const printWindow = window.open('', '_blank');
      const currentDate = new Date().toLocaleString();
      
      // Generate table rows
      let tableRows = '';
      this.filteredItems.forEach((item, index) => {
        tableRows += `
          <tr>
            <td style="padding: 8px; border: 1px solid #ddd;">${index + 1}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">${this.escapeHtml(item.patient_id?.toString() || '')}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">${this.escapeHtml(item.name)}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">0${item.contact || ''}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">${this.escapeHtml(item.address || '')}</td>
            <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${this.formatCurrency(item.debt)}</td>
          </tr>
        `;
      });
      
      // Get active filters for display
      const activeFilters = [];
      if (this.appliedFilters.debtMin) activeFilters.push(`Min Debt: ${this.formatCurrency(this.appliedFilters.debtMin)}`);
      if (this.appliedFilters.debtMax) activeFilters.push(`Max Debt: ${this.formatCurrency(this.appliedFilters.debtMax)}`);
      if (this.appliedFilters.address) activeFilters.push(`Address: ${this.appliedFilters.address}`);
      if (this.appliedFilters.name) activeFilters.push(`Name: ${this.appliedFilters.name}`);
      if (this.appliedFilters.telephone) activeFilters.push(`Telephone: ${this.appliedFilters.telephone}`);
      if (this.appliedFilters.patientId) activeFilters.push(`Patient ID: ${this.appliedFilters.patientId}`);
      
      // Write the HTML content
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Patient Debts Report</title>
          <style>
            @media print {
              body {
                margin: 0;
                padding: 20px;
              }
              .no-print {
                display: none;
              }
              .print-container {
                display: block;
              }
              table {
                page-break-inside: avoid;
              }
              tr {
                page-break-inside: avoid;
                page-break-after: avoid;
              }
              thead {
                display: table-header-group;
              }
              tfoot {
                display: table-footer-group;
              }
            }
            
            body {
              font-family: Arial, Helvetica, sans-serif;
              padding: 20px;
              margin: 0;
            }
            
            .print-header {
              text-align: center;
              margin-bottom: 20px;
              padding-bottom: 10px;
              border-bottom: 2px solid #333;
            }
            
            .print-header h1 {
              color: #2c3e50;
              margin: 0 0 10px 0;
            }
            
            .print-header p {
              color: #7f8c8d;
              margin: 5px 0;
            }
            
            .print-summary {
              margin-bottom: 20px;
              padding: 15px;
              background-color: #f5f5f5;
              border-radius: 5px;
            }
            
            .print-summary table {
              width: 100%;
              border: none;
            }
            
            .print-summary td {
              padding: 5px;
              border: none;
            }
            
            .totals-box {
              background-color: #e8f4f8;
              padding: 15px;
              margin-bottom: 20px;
              border-radius: 5px;
              text-align: right;
            }
            
            .totals-box h3 {
              margin: 0;
              color: #27ae60;
            }
            
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
              font-size: 12px;
            }
            
            th {
              background-color: #34495e;
              color: white;
              padding: 10px;
              border: 1px solid #2c3e50;
              text-align: left;
            }
            
            td {
              padding: 8px;
              border: 1px solid #ddd;
            }
            
            tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            
            .print-footer {
              text-align: center;
              margin-top: 30px;
              padding-top: 20px;
              border-top: 1px solid #ddd;
              font-size: 10px;
              color: #7f8c8d;
            }
            
            .print-button {
              text-align: center;
              margin-bottom: 20px;
            }
            
            button {
              background-color: #3498db;
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 5px;
              cursor: pointer;
              font-size: 14px;
              margin: 0 5px;
            }
            
            button:hover {
              background-color: #2980b9;
            }
            
            .text-right {
              text-align: right;
            }
          </style>
        </head>
        <body>
          <div class="print-button no-print">
            <button onclick="window.print();">🖨️ Print / Save as PDF</button>
            <button onclick="window.close();" style="background-color: #95a5a6;">❌ Close</button>
          </div>
          
          <div class="print-container">
            <div class="print-header">
              <h1>Patient Debts Report</h1>
              <p>Generated on: ${currentDate}</p>
            </div>
            
            <div class="print-summary">
              <table>
                <tr>
                  <td><strong>Report Summary:</strong></td>
                  <td class="text-right">Total Patients with Debt: ${this.filteredListLength}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Average Debt: ${this.formatCurrency(this.averageDebt)}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Highest Debt: ${this.formatCurrency(this.maxDebt)}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Lowest Debt: ${this.formatCurrency(this.minDebt)}</td>
                </tr>
                ${activeFilters.length > 0 ? `
                <tr>
                  <td><strong>Active Filters:</strong></td>
                  <td class="text-right">${activeFilters.join(' | ')}</td>
                </tr>
                ` : ''}
              </table>
            </div>
            
            <div class="totals-box">
              <h3>Total Outstanding Debt: ${this.formatCurrency(this.totalDebt)}</h3>
            </div>
            
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Patient ID</th>
                  <th>Name</th>
                  <th>Contact</th>
                  <th>Address</th>
                  <th>Debt Amount</th>
                </tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="5" style="text-align: right;">Total:</th>
                  <th style="text-align: right;">${this.formatCurrency(this.totalDebt)}</th>
                </tr>
              </tfoot>
            </table>
            
            <div class="print-footer">
              <p>This report was generated automatically from the Patient Management System.</p>
              <p>Printed on: ${currentDate}</p>
            </div>
          </div>
        </body>
        </html>
      `);
      
      printWindow.document.close();
      printWindow.focus();
    },
    
    // Helper function to escape HTML characters
    escapeHtml(text) {
      if (!text) return '';
      const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };
      return text.replace(/[&<>"']/g, function(m) { return map[m]; });
    }
  },
};
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}

@media print {
  .btn {
    display: none;
  }
}
</style>